import FormInput from "../../../../../../components/Form/FormInput";
import { AreaEmpresa } from "../../../../../../types/AreaEmpresa";

type ModalAreaProp = {
    areaForm: AreaEmpresa;
    setAreaForm: (value: AreaEmpresa) => void;
    formErrors: any;
    soloLectura?: boolean;
}

const ModalArea = ({ areaForm, setAreaForm, formErrors, soloLectura = false }: ModalAreaProp) => {

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setAreaForm({
            ...areaForm,
            [name]: value
        })
    }

    return (
        <>
            <div className="row mt-2">
                <FormInput
                    id={'nombreArea'}
                    label={'Área'}
                    name={'nombreArea'}
                    value={areaForm.nombreArea || ''}
                    isDisabled={true}
                    classLabel="col-form-label col-4 text-end"
                    classColumn="col-6"
                />
            </div>
            <div className="row mt-2">
                <FormInput
                    id={'email'}
                    label={'Mail'}
                    name={'email'}
                    value={areaForm.email || ''}
                    onChange={handleInputChange}
                    isDisabled={soloLectura}
                    classLabel="col-form-label col-4 text-end"
                    classColumn="col-6"
                    errorText={formErrors.email}
                    type='email'
                    maxLength={100}
                />
            </div>
        </>
    )
}

export default ModalArea;
